import React from 'react';

export const MetricCard = ({ id, label, value, note, tone = 'blue' }) => {
  const tones = {
    blue: 'border-blue-200 bg-blue-50 text-blue-950',
    emerald: 'border-emerald-200 bg-emerald-50 text-emerald-950',
    amber: 'border-amber-200 bg-amber-50 text-amber-950',
    red: 'border-red-200 bg-red-50 text-red-950',
    slate: 'border-slate-200 bg-white text-slate-950',
  };
  return (
    <div className={`min-h-28 rounded-lg border p-4 ${tones[tone] || tones.slate}`} data-testid={`metric-${id}`}>
      <p className="text-xs font-semibold uppercase text-slate-600">{label}</p>
      <p className="mt-3 text-3xl font-bold" data-testid={`metric-${id}-value`}>{value}</p>
      {note && <p className="mt-1 text-xs text-slate-600">{note}</p>}
    </div>
  );
};